 export default {
    newcustomer: require('./new-customer/new-customer.svg'),
    vectoropen: require('./vector-open/vector-open.svg'),
    vectorclose: require('./vector-close/vector-close.svg'),
    error: require('./error/error.svg')
};